export class Application {

	// constructor() {}

	lead(e, obj) {

		e.preventDefault()
		let _this = this
		let start = performance.now()
		let loader = document.querySelector('#call_request > .form__loader')
		loader.classList.add('active')

		let yaClient = '';
		if (window.hasOwnProperty('yaCounter87397587'))
			yaClient = yaCounter87397587.getClientID();

		$.ajax({
			url: "/ajax.php?mid=10",
			type: 'POST',
			data: {
				action: 'application',
				from: obj.from.value,
				name: obj.name.value,
				tel: obj.tel.value,
				yaClientID: yaClient,
			},
			dataType: "json",
			success: function (res) {
				if (res['error']) {
					alert(res['error'])
				} else {
					let form = document.querySelector('#call_request > .form__main')
					let formSuccess = document.querySelector('#call_request > .form__success')
					_this.prepareTime(form, formSuccess, loader, start)
					if (window.hasOwnProperty('yaCounter87397587'))
					    if (obj.from.value === "header")
					        yaCounter87397587.reachGoal('CallBackTop')
					    if (obj.from.value === "steps")
					        yaCounter87397587.reachGoal('CallBackMiddle')
				}
			},
			error: function (error) {
				alert('Ошибка отправки данных! Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта')
			}
		})

	}

	showSuccess(form, formSuccess, loader) {
		form.style.display = 'none'
		formSuccess.style.display = 'block'
		loader.classList.remove('active')
	}

	prepareTime(form, formSuccess, loader, start) {
		let _this = this
		let end = performance.now()
		let time = end - start
		if (time < 200) {
			time = 200 - time
			setTimeout(function () { _this.showSuccess(form, formSuccess, loader) }, time);
		} else {
			this.showSuccess(form, formSuccess, loader)
		}
	}

}